import { ApiUser } from "../../../api/v1.1/types/users";
import { AuthState, DEFAULT_UI_STATE, State } from "../types";

export interface LoginUserByTokenStartAction {
  authString: string;
  type: "LOGIN USER BY TOKEN START";
  token: string;
}
export interface LoginUserByFormStartAction {
  email: string;
  password: string;
  type: "LOGIN USER BY FORM START";
}
export interface LoginUserSuccessAction {
  authString: string;
  token: string;
  type: "LOGIN USER SUCCESS";
  user: ApiUser;
}
export interface LogoutAction {
  type: "LOGOUT";
}
export interface LoginRequestFailedAction{
  type: "LOGIN REQUEST FAILED";
}

export const loginUserByTokenStart = (state: State, action: LoginUserByTokenStartAction): State => {
  return {
    ...state,
    auth: {
      authString: action.authString,
      state: AuthState.loggingInByStorage,
      token: action.token,
    },
  };
};
export const loginUserByFormStart = (state: State, action: LoginUserByFormStartAction): State => {
  return {
    ...state,
    auth: {
      email: action.email,
      password: action.password,
      state: AuthState.loggingInByForm,
    },
  };
};

export const loginUserSuccess = (state: State, action: LoginUserSuccessAction): State => {
  return {
    ...state,
    auth: {
      activeKey: action.user.api_keys.live === action.token ? "live" : "test",
      authString: action.authString,
      state: AuthState.loggedIn,
      token: action.token,
      user: action.user,
    },
  };
};

export const logout = (_state: State, _: LogoutAction): State => {
  return {
    ...DEFAULT_UI_STATE,
    auth: {
      state: AuthState.notLoggedIn,
    },
  };
};

export const loginRequestFailed = (_state: State, _: LoginRequestFailedAction): State => {
  return {
    ...DEFAULT_UI_STATE,
    auth: {
      state: AuthState.requestFailed,
    },
  };
};
